import { useContext, useState, useEffect } from "react";
import { Tabs } from "rsuite";
import { useData } from "@microsoft/teamsfx-react";
import * as axios from "axios";
import Recent from "./Recent";
import Contacts from "./Contacts";
import { TeamsFxContext } from "./Context";
import "rsuite/Tabs/styles/index.css";
import { app, authentication } from "@microsoft/teams-js";
import { getGraphClient } from "./lib/graphClient";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import config from "./lib/config";

const SideBar = (props) => {
  const [needConsent, setNeedConsent] = useState(false);
  const teamsUserCredential = useContext(TeamsFxContext).teamsUserCredential;
  const { instance, accounts } = useMsal();
  const [respdata, setRespData] = useState({
    recentcontacts: "",
    personalcontact: "",
  });
  const [msalToken, setMsalToken] = useState("");

  const email = props.accountemail;

  const request = {
    ...loginRequest,
    account: accounts[0],
  };

  async function callRecentContacts() {
    try {
      const graphClient = getGraphClient(msalToken);

      const response = await graphClient.api("/me/people?$top=10").get();

      return response;
    } catch (err: unknown) {
      setNeedConsent(true);
      if (axios.default.isAxiosError(err)) {
        let funcErrorMsg = "";

        funcErrorMsg = err.message;
        if (err.response?.data?.error) {
          funcErrorMsg += ": " + err.response.data.error;
        }

        throw new Error(funcErrorMsg);
      }
      throw err;
    }
  }

  async function callPersonalContacts() {
    try {
      const graphClient = getGraphClient(msalToken);

      const response = await graphClient.api("/me/contacts?$top=1000").get();

      return response;
    } catch (err: unknown) {
      setNeedConsent(true);
      if (axios.default.isAxiosError(err)) {
        let funcErrorMsg = "";

        funcErrorMsg = err.message;
        if (err.response?.data?.error) {
          funcErrorMsg += ": " + err.response.data.error;
        }

        throw new Error(funcErrorMsg);
      }
      throw err;
    }
  }

  const openPopup = async () => {
    try {
      console.log("Start Authentication");
      const authUrl = new URL(window.location.origin + "/login");
      const result = await authentication.authenticate({
        url: authUrl.toString(),
        width: 600,
        height: 500,
      });
    } catch (error) {
      console.error("Authentication failed:", error);
    }
    try {
        const response = await axios.default.get(`https://integration.emetrotel.net/auth/refresh`, {
          params: { email },  // pass email as query param
          withCredentials: true, // include cookies if using sessions
        });
        setMsalToken(response.data.accessToken);
      } catch (err) {
        setMsalToken('');
        console.error('Failed to get access token:', err);
      }   
  };

  useEffect(() => {
    console.log("use effect recent contact");
    const fetchContacts = async () => {
      console.log("use token :", msalToken);
      if (msalToken && !respdata.personalcontact) {
        const recentcontacts = await callRecentContacts();
        const personalcontact = await callPersonalContacts();

        setRespData({
          recentcontacts: recentcontacts.value,
          personalcontact: personalcontact.value,
        });
      }
    };
    console.log("use effect fetched contact");
    fetchContacts();
  });

  useEffect(() => {

    const fetchAccessToken = async () => {
      try {
        const response = await axios.default.get(`https://integration.emetrotel.net/auth/refresh`, {
          params: { email },  // pass email as query param
          withCredentials: true, // include cookies if using sessions
        });
        setMsalToken(response.data.accessToken);
      } catch (err) {
        setMsalToken('');
        console.error('Failed to get access token:', err);
      }
    };

    fetchAccessToken();
  },[email]);

  return (
    <>
      <h4 className="sideBarTitle">Contacts</h4>
      {!msalToken && (
        <>
          <button
            className="mt-3 btn submit-btn reload ms-2"
            onClick={openPopup}
          >
            Authorize Now
          </button>
        </>
      )}
      {msalToken && (
        <Tabs defaultActiveKey="1">
          <Tabs.Tab eventKey="1" title="Teams">
            {respdata.recentcontacts.length > 0 ? (
              <Recent
                recentcontacts={respdata.recentcontacts}
                accountemail={props.accountemail}
              />
            ) : (
              <div className="no-contacts">No recent contacts found.</div> // Or any other fallback JSX or null
            )}
          </Tabs.Tab>
          <Tabs.Tab eventKey="2" title="Personal">
            {respdata.personalcontact.length > 0 ? (
              <Contacts
                personalcontacts={respdata.personalcontact}
                accountemail={props.accountemail}
              />
            ) : (
              <div className="no-contacts">No personal contacts found.</div> // Or any other fallback JSX or null
            )}
          </Tabs.Tab>
        </Tabs>
      )}
    </>
  );
};

export default SideBar;
